<template>
  <!-- I haven't made any change to this template. This is only copy and paste from doc site. -->
  <div>
    <v-container>
      <v-layout row wrap>
        <v-flex xs4>
          <div class="form-control">
            <div style="position: relative">
              <input class="mb-0" placeholder="Search" v-model="input.search" type="text" />
              <v-btn style="position: absolute; right: 5px; top: 5px" class="ma-0" icon
                ><v-icon color="primary">search</v-icon></v-btn
              >
            </div>
          </div>
        </v-flex>
        <v-flex xs8>
          <div class="text-xs-right">
            <importxlsx @onChange="importCsv"></importxlsx>
            <exportxlsx v-model="xlsxdata"></exportxlsx>
          </div>
        </v-flex>
      </v-layout>
      <v-data-table :headers="headers" :items="items" hide-actions class="elevation-1">
        <template slot="items" slot-scope="props">
          <tr @click="showDetail(props.item)" style="cursor: pointer">
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.locationgroup }}</td>
            <td>{{ props.item.location }}</td>
            <td>{{ props.item.building }}</td>
            <td>{{ props.item.province }}</td>
            <td class="text-xs-right">
              <toggle-button
                :value="props.item.status"
                :sync="true"
                :color="$vuetify.theme.success"
                @change="onChangeBranchStatus(props.index)"
                :labels="{ checked: 'ON', unchecked: 'OFF' }"
                style="display: inline-block"
              />
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-container>
    <v-dialog v-model="detaildialog" width="600px">
      <v-card>
        <div class="text-xs-right">
          <v-btn @click="detaildialog = false" icon><v-icon>close</v-icon></v-btn>
        </div>
        <div><BranchDetail></BranchDetail></div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { ToggleButton } from 'vue-js-toggle-button'
import importxlsx from '@/components/elements/importxlsx.vue'
import exportxlsx from '@/components/elements/exportxlsx.vue'
import BranchDetail from './BranchDetail.vue'
export default {
  components: {
    exportxlsx,
    importxlsx,
    ToggleButton,
    BranchDetail,
  },
  data: () => ({
    detaildialog: false,
    detaildata: '',
    input: {
      search: '',
    },
    headers: [
      {
        text: 'Name',
        align: 'center',
        // sortable: false,
        value: 'name',
      },
      {
        text: 'Location Group (Name)',
        align: 'center',
        value: 'locationgroup',
      },
      { text: 'สถานที่', align: 'center', value: 'location' },
      { text: 'ห้าง/อาคาร', align: 'center', value: 'building' },
      { text: 'จังหวัด', align: 'center', value: 'province' },
      { text: 'Branch Status', align: 'center', value: 'status', sortable: false },
    ],
    items: [
      {
        name: 'Studio 7-Paradise Park',
        locationgroup: 'Paradise Park',
        location: 'Srinakarin',
        building: 'Paradise Park',
        province: 'Bangkok',
        status: false,
      },
    ],
  }),

  computed: {
    ...mapGetters(['selectedBot']),
    xlsxdata() {
      var json = this.items.map((el) => {
        return {
          'Image url': el.image_url,
          Title: el.title,
          Category: el.category,
          Keyword: el.keyword,
          'Short Description': el.description,
        }
      })
      return json
    },
  },

  methods: {
    showDetail(item) {
      this.detaildialog = true
      this.detaildata = item
    },
    onChangeBranchStatus(index) {
      this.items[index].status = !this.items[index].status
    },
    importCsv(file) {
      console.log(file)
    },
    deleteItem(item) {
      const index = this.items.indexOf(item)
      confirm('Are you sure you want to delete this item?') && this.items.splice(index, 1)
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/view/ticket2/productandbranch/Branch.vue